const steps = [
  {
    n: "1",
    h: "Upload your data",
    p: "Export your inventory and sales data as a CSV or Excel file. Works with any POS, spreadsheet, or ERP export — no integrations needed.",
  },
  {
    n: "2",
    h: "Stock Move analyses it",
    p: "We calculate movement velocity, days cover, cash blocked, and SKU-level performance across categories and brands automatically.",
  },
  {
    n: "3",
    h: "Get clear action points",
    p: "Receive a prioritised list of what to clear, what to stop reordering, and where your cash is blocked — plain language, no jargon.",
  },
];

export default function HowItWorks() {
  return (
    <div className="sm-section-full" id="how-it-works">
      <div className="sm-section">
        <div className="sm-reveal" style={{ textAlign: "center" }}>
          <span className="sm-eyebrow">How It Works</span>
          <h2 className="sm-h2" style={{ maxWidth: 520, margin: "0 auto 12px" }}>
            From messy data
            <br />
            to clear decisions
          </h2>
          <p className="sm-h2-sub" style={{ margin: "0 auto" }}>
            Three steps. No technical setup. Results you can act on the same day.
          </p>
        </div>

        <div className="sm-steps">
          {steps.map((step, index) => (
            <div key={index} className={`sm-step sm-reveal sm-reveal-d${index + 1}`}>
              <div className="sm-step-num">{step.n}</div>
              <h3 className="sm-step-h3">{step.h}</h3>
              <p className="sm-step-p">{step.p}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}